import useModal from '../../hooks/useModal';
import DialogWrapper from '../custom-ui/dialog/Dialog_NewUI';

import CreatePostForm from './Component/CreatePostForm';
import ToastAlert from '../custom-ui/toast-alert/ToastAlert';

const CreatePost = () => {
    const { isShowing, toggle }: any = useModal();
    return (
        <>
            <div className=''>
                <button onClick={() => toggle()} className='text-white px-6 py-[6px] bg-instant-teams-blue-Main'>
                    Create New Post
                </button>
            </div>
            {isShowing &&
                <DialogWrapper
                    title="Create New Post"
                    onClose={toggle}
                    displayCloseIcon={true}
                    size="w-[calc(100%-1.5rem)] max-w-[640px]"
                    scrollAtEdge={true}
                    panelClassName="rounded-[16px]"
                    contentClassName="px-8 sm:px-10"
                >
                    <CreatePostForm toggleModal={toggle} />
                </DialogWrapper>}
            <ToastAlert />
        </>
    );
}

export default CreatePost;
